import React from 'react';
import { localeStrings as strings } from 'applicationConfig';

const ShellCaption = (props) => {
  const captionKey = props.captionKey in strings.pageCaptions ? props.captionKey : 'default';
  return (
    <div className="fix-widthed page-caption">
      <h5 className="page-subtitle">
        {strings.pageCaptions[captionKey]}
      </h5>
    </div>
  );
};

export default ShellCaption;



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/ShellCaption.jsx